export default __webpack_public_path__ + "static/coming-soon-overlay-e57d60141fb851c97aefce9cc6a1d692.jpg";